import { Box, BoxProps, forwardRef, getToken, useStyleConfig, useTheme } from '@chakra-ui/react';

export interface SkeletonProps extends BoxProps {
  isActive?: boolean;
  foregroundColor?: string;
}

/**
 * Skeleton is used to display the loading state of some component.
 *
 * We don't extend Chakra's Skeleton
 */
const Skeleton = forwardRef<SkeletonProps, 'div'>((props, ref) => {
  const { foregroundColor: foregroundColorToken, isActive, ...rest } = props;
  const theme = useTheme();
  const foregroundColor = foregroundColorToken
    ? getToken('colors', foregroundColorToken, foregroundColorToken)(theme)
    : '#ffffff';
  const css = useStyleConfig('Skeleton', {
    foregroundColor,
    isActive,
  });

  return <Box __css={css} {...rest} ref={ref} />;
});

export default Skeleton;
